import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserCareProgramsService} from '@shared/api/services/v2/user-care-programs.service';
import {UserCareProgramModuleEntry} from '@shared/api/models/query/user-care-program.model';

@Component({
    selector: 'cdss-chapter-detail-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chapter-detail-modal.component.html',
    styleUrl: './chapter-detail-modal.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class ChapterDetailModalComponent implements OnInit {

    @Input() userCareProgramId!: number;
    @Input() moduleId!: number;

    entry: UserCareProgramModuleEntry | null = null;
    loading = true;
    error = false;

    constructor(
        public modal: NgbActiveModal,
        private userCareProgramsService: UserCareProgramsService,
    ) {}

    ngOnInit(): void {
        this.userCareProgramsService.getModule(this.userCareProgramId, this.moduleId).subscribe({
            next: (entry) => {
                this.entry = entry;
                this.loading = false;
            },
            error: () => {
                this.error = true;
                this.loading = false;
            }
        });
    }

    progressPct(value: number): number {
        return Math.round((value ?? 0) * 100);
    }
}
